// Small shared helpers for the raffle UI.

export const getInitials = (fullName = '') => {
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Deterministic 0..3 variant so avatars get subtle, theme-aware tints
// (defined in CSS) instead of loud per-user gradients.
export const avatarVariant = (seed = '') => {
  let hash = 0;
  const str = String(seed);
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash % 4;
};

// Parse a native <input type="date"> value ("YYYY-MM-DD") into the first/last
// instant of that day in the browser's local timezone. Manual split (rather
// than `new Date(value)`, which parses as UTC midnight) so the calendar day
// the admin picked matches the calendar day sent to the backend regardless
// of timezone offset.
export const toStartOfDay = (value) => {
  if (!value) return null;
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
};

export const toEndOfDay = (value) => {
  if (!value) return null;
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 23, 59, 59, 999);
};
